import { render } from "./LinkageResetPassword.vue?vue&type=template&id=9887a5a6&scoped=true&ts=true"
import script from "./LinkageResetPassword.vue?vue&type=script&lang=ts"
export * from "./LinkageResetPassword.vue?vue&type=script&lang=ts"

import "./LinkageResetPassword.vue?vue&type=style&index=0&id=9887a5a6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1253990065/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9887a5a6"]])

export default __exports__